module.exports = __webpack_public_path__ + "static/media/loading-background.6b84a299.png";